<ng-container *ngIf="card$ | async as memberCard; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div class="barcode-card mb-lg-0" [ngClass]="{ 'border-radius': borderRadius }">
    <div class="d-flex flex-column">
      <!--Name and ID-->
      <div *ngIf="!displayQrCode" class="d-flex justify-content-between">
        <div class="card-id text-start">
          <p class="mb-0 card-name" *ngIf="memberDetails$ | async as memberDetails">
            {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
          </p>
          <div class="d-flex font-size-12">
            {{ ('member.card.id' | translate) + ' : ' + memberCard.ExternalRefNumber }}
          </div>
        </div>
        <ng-container *notInProductCode="productCode.NonRenewing">
          <button
            type="button"
            class="btn show-card-modal gloss d-flex justify-content-center align-items-center text-white"
            (click)="navigateToWallet()"
            *ngIf="!displayQrCode"
          >
            <span class="icon material-icons"> qr_code_2 </span>
            <span class="ms-1">{{ 'member.card.wallet' | translate }}</span>
          </button>
        </ng-container>
      </div>
      <!-- qr code -->
      <ng-container *notInProductCode="productCode.NonRenewing">
        <div
          class="qr-container mt-2 d-flex flex-column justify-content-center align-items-center gloss text-white rounded"
          *ngIf="displayQrCode && barcode$ | async as barcode"
        >
          <ng-container *ngIf="barcode.Barcode; else loadingRef">
            <qrcode [width]="128" [qrdata]="barcode?.Barcode" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
            <p class="m-0 font-size-12 text-center mt-3">{{ 'wallet.barcode.scanqr' | translate }}</p>
          </ng-container>
        </div>
      </ng-container>
      <!--Balances-->
      <div *notInProductCode="productCode.NonRenewing" class="card-detail d-flex align-items-center mt-3 gloss">
        <div class="card-id text-center d-flex w-100 justify-content-between" *ngIf="pointsBalance$">
          <div class="font-size-12 mt-1">{{ 'member.card.points.balance' | translate }}</div>
          <div class="d-flex">
            <span class="icon material-icons currency-icons pe-2">loyalty</span>
            <label class="font-size-18 mb-0 font-heading">{{ pointsBalance$ | async | number : '1.0-0' }}</label>
          </div>
        </div>
      </div>
      <div *ngIf="showDiscounts" class="d-flex flex-column align-items-center my-3 gap-2">
        <ng-container *ngIf="memberCard.RetailDiscountLevel?.length > 0">
          <div class="card-id text-center d-flex w-100 justify-content-between">
            <div class="font-size-14">{{ 'member.card.retail.discount' | translate }}</div>
            <label class="font-size-14 mb-0">{{ memberCard.RetailDiscountLevel + '%' }}</label>
          </div>
        </ng-container>
        <ng-container *ngIf="memberCard.DiscountLevel?.length > 0">
          <div class="card-id text-center d-flex w-100 justify-content-between">
            <div class="font-size-14">{{ 'member.card.discount' | translate }}</div>
            <label class="font-size-14 mb-0">{{ memberCard.DiscountLevel + '%' }}</label>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<!--Barcode Modal-->
<div class="modal fade" id="barcodeModal" tabindex="-1" aria-labelledby="barcodeModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <ng-container *ngIf="card$ | async as memberCard">
      <div class="modal-content bg-white border-0" *ngIf="barcode$ | async as barcode">
        <div class="modal-body p-0 flex-column align-items-center d-flex flex-wrap justify-content-around mt-4">
          <!--Name and ID-->
          <div class="card-id text-start">
            <div class="d-flex justify-content-center">
              <p class="mb-0 card-name text-primary text-center font-size-16" *ngIf="memberDetails$ | async as memberDetails">
                {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
              </p>
              <div class="icon material-icons close-icon text-grey" data-bs-dismiss="modal">close</div>
            </div>
            <div class="d-flex font-size-10">
              <div>{{ memberCard.ProductCode }}</div>
              <div class="px-1">-</div>
              <div>ID: {{ memberCard.ExternalRefNumber }}</div>
            </div>
          </div>
          <div class="qr px-2 bg-white">
            <qrcode [qrdata]="barcode.Barcode" [size]="256" [level]="'M'" [usesvg]="true"></qrcode>
          </div>
          <div class="w-100 bg-primary">
            <!--Balances-->
            <div class="d-flex justify-content-between align-items-center text-white balance-section">
              <div class="card-id text-start ps-4" *ngIf="pointsBalance$">
                <label class="font-size-14 mb-1">{{ pointsBalance$ | async | number : '1.0-0' }}</label>
                <div class="font-size-12">{{ 'member.card.points.balance' | translate }}</div>
              </div>

              <ng-container *ngIf="memberCard.RetailDiscountLevel?.length > 0">
                <div class="balance-splitter mx-3"></div>
                <div class="card-id text-start">
                  <label class="font-size-14 mb-0">{{ memberCard.RetailDiscountLevel + '%' }}</label>
                  <div class="font-size-12">{{ 'member.card.retail.discount' | translate }}</div>
                </div>
              </ng-container>
              <ng-container *ngIf="memberCard.DiscountLevel?.length > 0">
                <div class="balance-splitter mx-3"></div>
                <div class="card-id text-start">
                  <label class="font-size-14 mb-0">{{ memberCard.DiscountLevel + '%' }}</label>
                  <div class="font-size-12">{{ 'member.card.discount' | translate }}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
